<template>
  <div>
    <el-popover placement="bottom-start" width="500" popper-class="pop-ht-city" ref="popCityGeo" @show="showPopver"
      @hide="hidePopver" v-model="visible" :close-delay="0" trigger="click">
      <div>
        <div class="search-ht-city-result-content scroll-geo" v-if="!!searchCityList && searchCityList.length > 0">
          <p v-for="(item, index) in searchCityList" :key="index" :class="[
            'search-ht-city-result',
            index == 0 ? 'red' : '',
          ]" @click="checkBtnSearch(item)">
            <span>{{ item.nameCn }}</span>
            <span>{{ item.name }}</span>
          </p>
        </div>
        <div class="search-ht-city-result-content" v-else>暂无数据</div>
      </div>
      <el-input size="large" style="width: 200px" :disabled="!cityId" placeholder="关键字/酒店/地址" v-model="keywords"
        @input.native="inputKeywordEvent" slot="reference">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </el-popover>
  </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import common from '../../plugins/common';

export default {
  name: 'IntHtKeyword',
  props: {
    cityId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentPageCity: 1,
      activeIndex: -1,
      activeIndexSub: -1,
      visible: false,
      geoLocationList: [],
      searchCityBool: false,
      cityTimeStamp: 0,
      searchCityList: [],
    }
  },
  computed: {
    ...mapState({
      htCnQuery: (state) => state.intHt.htCnQuery,
      htCnParams: (state) => state.intHt.htCnParams,
    }),
    tripType() {
      return this.htCnQuery.tripType
    },
    keywords: {
      get() {
        return this.htCnParams.keywords
      },
      set(val) {
        this.SET_HTCN_PARAMS({ keywords: val })
      },
    },
  },
  mounted() {
  },
  watch: {
    cityId: {
      handler(value, oldvalue) {
        if (value != oldvalue) {
          this.keywords = ''
        }
        this.inputKeywordEvent();
      },
      immediate: true,
      deep: true
    },
    keywords(val) {
      if (!!val) {
        return;
      }
      this.searchCityList = []
      this.searchCityBool = true
      this.SET_HTCN_PARAMS({
        searchType: 0,
        keywords: '',
      })
    },
  },
  methods: {
    ...mapMutations({
      SET_HTCN_PARAMS: 'intHt/SET_HTCN_PARAMS'
    }),
    // 关键字查询
    inputKeywordEvent: common.debounce2(function (e) {
      if (!this.cityId) return;
      let term;
      if (!!e) {
        term = e.target.value
      }
      this.$conn
        .getConn('staticData.interHtKeyWordSearch', { jsfile: true })({
          cityId: this.cityId,
          keyWords: term || '',
          count: 50,
          pageNum: 1,
        })
        .then((res) => {
          let data = res.data || {};
          let list = data.list || [];
          this.searchCityList = list;
          this.searchCityBool = true;
          if (!!e) {
            this.$refs.popCityGeo.doShow()
          }
        })
    }, 300),
    // 内容移入事件
    enter(i, iSub) {
      this.activeIndex = i
      this.activeIndexSub = iSub
    },
    // 内容移出事件
    leave(i) {
      this.activeIndex = -1
      this.activeIndexSub = -1
    },
    // 内容点击事件
    checkBtn(val, type) {
      this.$emit('checkHtCityGeo', val)
    },
    // 关键字查询点击事件
    checkBtnSearch(val) {
      this.keywords = val.nameCn;
      this.$emit('checkHtCityGeo', val)
      this.$refs.popCityGeo.doClose()
    },
    // 监听弹框显示时的方法
    showPopver() {
      // 处理
      if (!this.cityId) {
        this.$refs.popCityGeo.doClose()
        this.$message({
          type: 'error',
          message: '请先选择城市',
        })
      }
    },
    // 监听弹框隐藏时的方法
    hidePopver() {
      // 处理
    },
  },
}
</script>

<style scoped lang="scss">
.pop-ht-city {
  .city-ht {
    height: 400px;
    overflow-y: scroll;

    .city-ht-item {
      display: flex;
      justify-content: flex-start;
    }

    .city-ht-btn {
      display: inline-block;
      margin-bottom: 10px;
      padding-right: 10px;
      width: 74px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;

      .city-ht-span {
        // 鼠标移入的hover
        visibility: hidden;
        width: 80px;
        background-color: #409eff;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        top: 80%;
        left: 80%;
        margin-left: -60px;
      }

      .city-ht-span::after {
        // 小箭头伪元素实现
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent rgba(64, 158, 255, 1) transparent;
      }
    }

    .city-ht-btn:hover .city-ht-span {
      visibility: visible;
    }
  }

  .search-ht-city-result-content {
    :hover {
      background-color: #eee;
      cursor: pointer;
    }

    padding-top: 10px;
  }

  .scroll-geo {
    height: 400px;
    overflow-y: scroll;
  }

  .search-ht-city-result {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
  }

  .red {
    color: #f00;
  }
}
</style>
